import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m7.825 13 4.9 4.9q.3.3.287.7-.012.4-.312.7-.3.276-.7.287a.92.92 0 0 1-.7-.287l-6.6-6.6a.9.9 0 0 1-.212-.325A1.1 1.1 0 0 1 4.425 12q0-.2.063-.375A.9.9 0 0 1 4.7 11.3l6.6-6.6a.93.93 0 0 1 .688-.275q.412 0 .712.275.3.3.3.712 0 .413-.3.713L7.825 11H19a.97.97 0 0 1 .712.287Q20 11.575 20 12c0 .425-.096.52-.288.713A.97.97 0 0 1 19 13z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }